import type { ExtractValues, SchemaOf } from '../helpers';
import { objectSchemaOf, Joi, makeAllOptional } from '../helpers';

export const envNames = ['LOCAL', 'DEV', 'TEST'] as const;

export type EnvNames = ExtractValues<typeof envNames>;

export interface IEnvConfig {
  name: EnvNames;
  cloudFunctionBaseUrl: string;
  timeUrl: string;
  pingServerBaseUrl: string;
  messageBrokerBaseUrl: string;
  appsBaseUrl: string;
}

export const envConfigSchemaMap: SchemaOf<IEnvConfig> = {
  name: Joi.string()
    .valid(...envNames)
    .required(),
  cloudFunctionBaseUrl: Joi.string().uri().required(),
  timeUrl: Joi.string().uri().required(),
  pingServerBaseUrl: Joi.string().uri().required(),
  messageBrokerBaseUrl: Joi.string().uri().required(),
  appsBaseUrl: Joi.string().uri().required(),
};

export const envConfigSchema = objectSchemaOf<IEnvConfig>(envConfigSchemaMap);

export const envConfigPartialSchemaMap = makeAllOptional(envConfigSchemaMap);

export const envConfigPartialSchema = objectSchemaOf<IEnvConfig>(
  envConfigPartialSchemaMap
);

export interface IEnvConfigMap<Conf extends IEnvConfig = IEnvConfig> {
  LOCAL?: Conf;
  DEV?: Conf;
  TEST?: Conf;
  [key: string]: Conf | undefined;
}
